import * as THREE from 'three'
import {setup} from "./setup"
import vertShader from "./shaders/vertShader.glsl"
import fragShader from "./shaders/fragShader.glsl"
import { RGBELoader } from './rgbeLoader.js'
// import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js' // this doesnt work!! maybe myversion had a bug?
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export function loadScene() {

    // console.log(setup);
    var {scene,renderer,camera} = setup;

    // console.log(scene);
    const gltfLoader = new GLTFLoader();

    gltfLoader.load(
        "./nike_scene.glb",
        function(gltf){

            console.log(gltf.scene);

            
            var shoe;
            var floor;
            var icosphere;
            gltf.scene.traverse((obj) => {
                if(obj.isMesh){
                    // console.log(obj);
                    if(obj.name == "defaultMaterial"){
                        shoe = obj;
                    } else if (obj.name == "plane") {
                        floor = obj;
                    } else if (obj.name == "background") {
                        icosphere = obj;
                    }
                }
            });



            var textureLoader = new THREE.TextureLoader();
            var rgbeLoader = new RGBELoader();

            const shoe_color = textureLoader.load("base_color.jpg");
            const shoe_direct = textureLoader.load("ShadowMap.png");
            const shoe_indirect = textureLoader.load("glossy_indirect.png");

            // shoe_color.flipY = false;
            // shoe_direct.flipY = false;
            // shoe_indirect.flipY = false;
            // shoe_color.encoding =  THREE.sRGBEncoding
            shoe_direct.encoding = THREE.sRGBEncoding
            shoe_indirect.encoding = THREE.sRGBEncoding

            const roughness_map = textureLoader.load("roughness_map.png"); 
            roughness_map.encoding = THREE.sRGBEncoding

            const normal_map = textureLoader.load("normal_map.png");

            // normal_map.flipY = false;

            const plane_direct = textureLoader.load("planeLighting_BW.png");
            plane_direct.flipY = false;
            // plane_direct.encoding = THREE.sRGBEncoding

            const env_0 = rgbeLoader.load("/env/outdoor/mip0.hdr");
            const env_1 = rgbeLoader.load("/env/outdoor/mip1.hdr");
            const env_2 = rgbeLoader.load("/env/outdoor/mip2.hdr");
            const env_3 = rgbeLoader.load("/env/outdoor/mip3.hdr");
            const env_4 = rgbeLoader.load("/env/outdoor/mip4.hdr");
            const env_5 = rgbeLoader.load("/env/outdoor/mip5.hdr");
            const env_6 = rgbeLoader.load("/env/outdoor/mip6.hdr");

            env_0.encoding = THREE.LinearEncoding;
            env_1.encoding = THREE.LinearEncoding;
            env_2.encoding = THREE.LinearEncoding;
            env_3.encoding = THREE.LinearEncoding;
            env_4.encoding = THREE.LinearEncoding;
            env_5.encoding = THREE.LinearEncoding;
            env_6.encoding = THREE.LinearEncoding;

            env_0.minFilter = THREE.LinearFilter;
            env_1.minFilter = THREE.LinearFilter;
            env_2.minFilter = THREE.LinearFilter;
            env_3.minFilter = THREE.LinearFilter;
            env_4.minFilter = THREE.LinearFilter;
            env_5.minFilter = THREE.LinearFilter;
            env_6.minFilter = THREE.LinearFilter;

            // var aoMap = textureLoader.load("aoMapSlippers2Denoise.png");
            // aoMap.flipY = false;

            //need 3 materials.

            const floor_material = new THREE.MeshBasicMaterial({
                map: plane_direct
            })

            // might need shader because the plane lighting is colored, or maybe i can just edit the map

            const background_material = new THREE.MeshBasicMaterial({
                side: THREE.BackSide,
            })

            const shoe_material = new THREE.ShaderMaterial({
                uniforms: {
                    iTime: { value: 0 },
                    color: {value: shoe_color},
                    direct: {value: shoe_direct},
                    indirect: {value: shoe_indirect},
                    roughness_map: { value: roughness_map },
                    normal_map: {value: normal_map},
                    env_0: { value: env_0 },
                    env_1: { value: env_1 },
                    env_2: { value: env_2 },
                    env_3: { value: env_3 },
                    env_4: { value: env_4 },
                    env_5: { value: env_5 },
                    env_6: { value: env_6 }

                },
                vertexShader: vertShader,
                fragmentShader: fragShader,
                // transparent: true
            });

            shoe.material = shoe_material;
            floor.material = floor_material;
            icosphere.material = background_material;
            // shoe.visible = false;


            scene.add(gltf.scene);
        }
    );

}